module.exports = __webpack_public_path__ + "img/901477498.39b45103.png";